<template>
  <div>
    <HeadInfo title="动漫" />
    <Episode />
    <Relative />
    <Actors />
    <Theater />
    <Like />
    <Gotop />
    <Rec />
    <Ob />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Gotop from '../common/components/Gotop.vue';
import pageExpose from '../common/mixins/pageExpose';
import Actors from './components/Actors.vue';
import Episode from './components/Episode.vue';
import HeadInfo from './components/HeadInfo.vue';
import Like from './components/Like.vue';
import Ob from './components/ObserveModule.vue';
import Rec from './components/Rec.vue';
import Relative from './components/Relative.vue';
import Theater from './components/Theater.vue';

export default {
  components: {
    HeadInfo,
    Episode,
    Relative,
    Actors,
    Like,
    Gotop,
    Rec,
    Ob,
    Theater,
  },
  mixins: [pageExpose],
  computed: {
    ...mapState('detail', ['itemData']),
  },
  asyncData({ context, store, route }) {
    return store
      .dispatch('detail/prefetchData', { context, route })
      .catch(err => console.log('[DETAIL_CARTOON_PREFETCH_ERROR]', err));
  },
};
</script>
